var React = require('react');

function IconWeeks (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#142b6f;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}")),React.createElement("polygon",{"points":"33.51 23.66 25.42 31.75 6.49 31.75 6.49 8.25 33.51 8.25 33.51 23.66","className":"cls-1","key":1}),React.createElement("line",{"x1":"6.48","x2":"33.52","y1":"14.59","y2":"14.59","className":"cls-1","key":2}),React.createElement("polyline",{"points":"25.42 31.75 25.42 23.66 33.51 23.66","className":"cls-1","key":3})]);
}

IconWeeks.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 40 40"};

module.exports = IconWeeks;

IconWeeks.default = IconWeeks;
